// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.logo[data-v-bb50a5e4] {\n  max-width: 100px; /* Set the maximum width for your logo */\n  width: 100%; /* Ensure the logo takes the full available width */\n  height: auto; /* This ensures the aspect ratio is maintained */\n  /* Add any other CSS styles you want to apply */\n}\n/* Add your header styles here */\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
